var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTcblacklogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_128_1",
    "data-name": "Component 128 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.111,
    height: 28.62,
    viewBox: "0 0 157.111 28.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_2",
    "data-name": "Component 3 \\u2013 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Type",
    transform: "translate(12.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M203.882,191.814h-1.515a.741.741,0,0,1-.707-.741v-2.289a.7.7,0,0,1,.707-.741h1.515v-4.31a.771.771,0,0,1,.741-.741h2.761a.719.719,0,0,1,.707.741v4.31h3.636a.726.726,0,0,1,.741.741v2.289a.771.771,0,0,1-.741.741h-3.636v7c0,1.044.5,1.279,1.279,1.279a10.275,10.275,0,0,0,2.357-.5.6.6,0,0,1,.875.4l.438,2.054a.758.758,0,0,1-.438.909,12.283,12.283,0,0,1-4.377,1.01c-3.468,0-4.344-2.323-4.344-5.017Z",
    transform: "translate(-201.66 -182.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M252.2,199.975a6.972,6.972,0,0,1,7.138,7.206q-.008.506-.067,1.01a.79.79,0,0,1-.741.707h-9.966a3.737,3.737,0,0,0,3.872,3.6,5.157,5.157,0,0,0,3.334-1.145c.37-.3.775-.337,1.01,0l1.313,1.751a.655.655,0,0,1-.067,1.01,8.784,8.784,0,0,1-5.791,2.121,8.136,8.136,0,0,1-.033-16.262Zm2.9,6.162a2.843,2.843,0,0,0-3-2.694,3.09,3.09,0,0,0-3.3,2.694Z",
    transform: "translate(-232.504 -195.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M304.286,201.052a.747.747,0,0,1,.741-.741h1.212a.6.6,0,0,1,.64.438l.572,1.481a5.914,5.914,0,0,1,4.748-2.256,5.3,5.3,0,0,1,4.647,2.357,6.639,6.639,0,0,1,5.017-2.357c4.983,0,6.161,3.165,6.161,7.206v7.946a.755.755,0,0,1-.774.741h-2.694a.747.747,0,0,1-.741-.741v-8.047c0-2.02-.741-3.266-2.694-3.266a2.972,2.972,0,0,0-2.9,1.616s.067.774.067,1.481v8.216a.77.77,0,0,1-.74.741h-2.761a.726.726,0,0,1-.741-.741v-8.047c0-2.02-.572-3.266-2.559-3.266a3.051,3.051,0,0,0-3,2.424v8.889a.77.77,0,0,1-.741.741h-2.727a.77.77,0,0,1-.741-.741Z",
    transform: "translate(-275.8 -195.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M406.228,216.238a11.56,11.56,0,0,1-3.737-.64v7.542a.8.8,0,0,1-.741.741h-2.727a.77.77,0,0,1-.741-.741V201.052a.747.747,0,0,1,.741-.741h1.245c.371,0,.606.3.741.741l.4,1.246a6.715,6.715,0,0,1,5.084-2.323c4.243,0,7.441,3.434,7.441,8.148C413.939,212.669,410.875,216.238,406.228,216.238Zm-3.737-4.714a6.152,6.152,0,0,0,3.232.875c2.559,0,3.872-2.088,3.872-4.276s-1.246-4.31-3.67-4.31a3.568,3.568,0,0,0-3.434,2.155Z",
    transform: "translate(-343.707 -195.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M468.209,199.975A7.7,7.7,0,0,1,474,202.6c.336.337.168.774-.169,1.111l-1.414,1.549c-.337.371-.707.2-1.011-.1a4.236,4.236,0,0,0-3.1-1.346,4.3,4.3,0,1,0,3.266,6.868.731.731,0,0,1,.977-.1l1.515,1.28c.371.337.539.707.269,1.111a6.963,6.963,0,0,1-6.161,3.266,8.132,8.132,0,1,1,.033-16.263Z",
    transform: "translate(-388.264 -195.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M521.82,199.975a8.133,8.133,0,1,1-7.946,8.081A8.084,8.084,0,0,1,521.82,199.975Zm0,12.424a4.217,4.217,0,0,0,4.074-4.344,4.061,4.061,0,1,0-8.115,0A4.19,4.19,0,0,0,521.82,212.4Z",
    transform: "translate(-427.215 -195.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M569.721,202.1c-.236-.472-.034-.909.538-.909h3.2a.717.717,0,0,1,.707.438L577.4,209.3h.068l3.434-7.677c.2-.4.539-.438.977-.438H584.7a.567.567,0,0,1,.539.909l-7,14.613a.792.792,0,0,1-.674.4h-.2a.79.79,0,0,1-.673-.4Z",
    transform: "translate(-467.49 -196.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M632.767,199.975a6.972,6.972,0,0,1,7.138,7.206c0,.236-.033.774-.067,1.01a.791.791,0,0,1-.741.707H629.13A3.738,3.738,0,0,0,633,212.5a5.157,5.157,0,0,0,3.334-1.145c.37-.3.774-.337,1.01,0l1.313,1.751a.655.655,0,0,1-.068,1.01,8.782,8.782,0,0,1-5.791,2.121,8.136,8.136,0,0,1-.034-16.262Zm2.9,6.162a2.843,2.843,0,0,0-3-2.694,3.089,3.089,0,0,0-3.3,2.694Z",
    transform: "translate(-507.439 -195.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M685.044,201.052a.747.747,0,0,1,.741-.741h1.246a.652.652,0,0,1,.673.5l.573,1.515a5.4,5.4,0,0,1,4.377-2.357c1.852,0,3.367.5,2.929,1.515l-1.01,2.29a.653.653,0,0,1-.909.337,3.1,3.1,0,0,0-1.448-.3,3.379,3.379,0,0,0-2.963,1.616v9.7c0,.572-.37.741-.876.741h-2.592a.77.77,0,0,1-.741-.741Z",
    transform: "translate(-550.874 -195.26)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(0 4.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 1.56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 14.031,
    height: 1.526,
    transform: "translate(0 3.034)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 14.031,
    height: 1.526,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 4.684,
    height: 1.132,
    transform: "translate(14.351 5.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11-2",
    "data-name": "Group 11",
    transform: "translate(11.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M211.144,201.029h0c0-2.2-1.227-2.288-1.77-2.349-.651-.073-1.1-.125-1.412-.148-.225-.017-1.418-.283-2.021-.365a16.761,16.761,0,0,0-3.423,0c-.429.072-1.328.4-1.907.55-.607.16-.925.09-1.18.276-.536.388-.508,2.013-.508,2.294,0,0-.028,1.631.508,2.02.4.289,2.035.4,5.061.4h4.883c.512,0,1.767.015,1.77-2.527h0v-.147Z",
    transform: "translate(-198.922 -198.078)",
    fill: "#71a7bf",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M202.608,203.688a9.088,9.088,0,0,1-.12-1.4,6.023,6.023,0,0,1,.142-1.3.39.39,0,0,1,.32-.32l1.415-.447c.148-.062.251.073.229.213,0,0-.09.756-.09,1.248a11.356,11.356,0,0,0,.092,1.2c.023.14-.073.24-.228.326l-1.456.708C202.733,203.992,202.628,203.829,202.608,203.688Z",
    transform: "translate(-201.498 -199.611)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M213.255,212.512h-4.186c-.839,0-.846-.409-.016-.671a6.5,6.5,0,0,1,1.782-.207C212.952,211.634,214.093,212.512,213.255,212.512Z",
    transform: "translate(-205.794 -207.871)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M226.091,203.483a.254.254,0,0,1-.365.139l-1.363-.737a.418.418,0,0,1-.22-.38,11.529,11.529,0,0,0,.114-1.324,13.287,13.287,0,0,0-.111-1.375.184.184,0,0,1,.22-.227l1.427.3a.342.342,0,0,1,.3.28,5.476,5.476,0,0,1,.213,1.639A6.134,6.134,0,0,1,226.091,203.483Z",
    transform: "translate(-217.14 -199.16)",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M206.259,217.008c0,.277-.431.5-.963.5s-.963-.225-.963-.5.431-.5.963-.5S206.259,216.731,206.259,217.008Z",
    transform: "translate(-202.831 -211.39)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M231.631,217.008c0,.277-.431.5-.963.5s-.963-.225-.963-.5.431-.5.963-.5S231.631,216.731,231.631,217.008Z",
    transform: "translate(-221.161 -211.39)",
    stroke: "#fff",
    strokeWidth: 1
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11-3",
    "data-name": "Group 11",
    transform: "translate(11.566 4.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10-2",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9-2",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68-2",
    "data-name": "Path 68",
    d: "M211.144,201.029h0c0-2.2-1.227-2.288-1.77-2.349-.651-.073-1.1-.125-1.412-.148-.225-.017-1.418-.283-2.021-.365a16.761,16.761,0,0,0-3.423,0c-.429.072-1.328.4-1.907.55-.607.16-.925.09-1.18.276-.536.388-.508,2.013-.508,2.294,0,0-.028,1.631.508,2.02.4.289,2.035.4,5.061.4h4.883c.512,0,1.767.015,1.77-2.527h0v-.147Z",
    transform: "translate(-198.922 -198.078)",
    fill: "#96b3d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_69-2",
    "data-name": "Path 69",
    d: "M202.608,203.688a9.088,9.088,0,0,1-.12-1.4,6.023,6.023,0,0,1,.142-1.3.39.39,0,0,1,.32-.32l1.415-.447c.148-.062.251.073.229.213,0,0-.09.756-.09,1.248a11.356,11.356,0,0,0,.092,1.2c.023.14-.073.24-.228.326l-1.456.708C202.733,203.992,202.628,203.829,202.608,203.688Z",
    transform: "translate(-201.498 -199.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70-2",
    "data-name": "Path 70",
    d: "M213.255,212.512h-4.186c-.839,0-.846-.409-.016-.671a6.5,6.5,0,0,1,1.782-.207C212.952,211.634,214.093,212.512,213.255,212.512Z",
    transform: "translate(-205.794 -207.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71-2",
    "data-name": "Path 71",
    d: "M226.091,203.483a.254.254,0,0,1-.365.139l-1.363-.737a.418.418,0,0,1-.22-.38,11.529,11.529,0,0,0,.114-1.324,13.287,13.287,0,0,0-.111-1.375.184.184,0,0,1,.22-.227l1.427.3a.342.342,0,0,1,.3.28,5.476,5.476,0,0,1,.213,1.639A6.134,6.134,0,0,1,226.091,203.483Z",
    transform: "translate(-217.14 -199.16)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72-2",
    "data-name": "Path 72",
    d: "M206.259,217.008c0,.277-.431.5-.963.5s-.963-.225-.963-.5.431-.5.963-.5S206.259,216.731,206.259,217.008Z",
    transform: "translate(-202.831 -211.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-2",
    "data-name": "Path 73",
    d: "M231.631,217.008c0,.277-.431.5-.963.5s-.963-.225-.963-.5.431-.5.963-.5S231.631,216.731,231.631,217.008Z",
    transform: "translate(-221.16 -211.39)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcblacklogo);
export default __webpack_public_path__ + "static/media/tcblacklogo.9d3dbab9db0b9e7f3ac64f5db7283281.svg";
export { ForwardRef as ReactComponent };